export default `---
slug: middle-school-competitions
type: extracurricular
dateRange: "2008 – 2009"
institution: "Scuola Media, Desenzano del Garda"
location: "Desenzano del Garda, Italy"
role: "Math & Logic Competition Winner"
current: false
skills: [Mathematics, Logic, Problem Solving]
relatedLinks: []
---

In middle school, me and my two best friends won the school math and logic competition two years in a row, and we competed at the province level. Even as a kid, the satisfaction of solving problems nobody else could crack was already addictive.
`;
